import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import compareDate from 'date-fns/compare_asc';

import { SUBSCRIPTION_FOOTER_TEXTS } from 'rebook/apps/payments/constants';
import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';
import PaymentsAvailableContentCounters from 'rebook/apps/payments/components/PaymentsAvailableContentCounters';
import PaymentsActionButton from 'rebook/apps/payments/components/PaymentsActionButton';
import PaymentsRibbon from 'rebook/apps/payments/components/PaymentsRibbon';
import CurrentSubscriptionLabel from 'rebook/apps/payments/components/CurrentSubscriptionLabel';

import styles from './style.scss';


const subscriptionIcons = {
  pro: <SubscriptionIcon type="premium" extraClassName={styles.image} />,
  standard: <SubscriptionIcon type="standard" extraClassName={styles.image} />,
};

const PaymentsSubscriptionTypeOffer = ({
  onSubscriptionTypeChange, type, payments,
  booksPerSubscriptionCounter, isShowOfferLink, user }) => {
  const { subscriptionTypes } = payments;
  const { price, description } = subscriptionTypes[type];
  const hasPremiumSubscription = subscriptionTypes.pro.userIsActive;
  const hasAudio = get(user, 'active_subscription_type', '') === 'audio';
  const hasPro = get(user, 'active_subscription_type', '') === 'pro';
  const isHasDifferentSubscriptions =
    get(user, 'subscription_pro_active_till', '') !== get(user, 'subscription_audio_active_till', '');
  const isTillAudioSubscriptionBeforePro = compareDate(
    get(user, 'subscription_pro_active_till', ''),
    get(user, 'subscription_audio_active_till', ''),
  ) == 1 ? true : false;
  const hasOldProSubscription = get(user, 'subscription_id', null) === 2;
  const isPro = type === 'pro';
  const fullPrice = {
    pro: get(payments, 'prices.audio["1"].full_price', 459),
    standard: get(payments, 'prices.standard["1"].full_price', 199),
  };

  const hasStandardSubscription = subscriptionTypes.standard.userIsActive;
  const subscriptionTypeTitle = isPro ? 'Премиум' : 'Стандарт';
  let isStandardSubscriptionLonger = (hasStandardSubscription && !hasPremiumSubscription)
    ? true
    : false;

  if (hasStandardSubscription && hasPremiumSubscription) {
    const standardSubscriptionTime = new Date(payments.subscriptionTypes.standard.userActiveTill).getTime();
    const premiumSubscriptionTime = new Date(payments.subscriptionTypes.pro.userActiveTill).getTime();

    isStandardSubscriptionLonger = standardSubscriptionTime > premiumSubscriptionTime;
  }

  let subscriptionTypeForLabel = null;
  if (hasPremiumSubscription) {
    subscriptionTypeForLabel = payments.subscriptionTypes.pro.userActiveTill;
  }
  else if (!isPro && hasStandardSubscription && !hasPremiumSubscription) {
    subscriptionTypeForLabel = payments.subscriptionTypes.standard.userActiveTill;
  }

  const isSurcharge = isPro
    && (
      (isStandardSubscriptionLonger || hasStandardSubscription)
      || (hasPremiumSubscription && !hasAudio)
    )
    && !(hasPremiumSubscription && hasAudio);

  const isProSubscriberBuysAudioSubscription = (isPro && hasPro && hasOldProSubscription)
    || (isPro && isHasDifferentSubscriptions && hasAudio && isTillAudioSubscriptionBeforePro);

  return (
    <div
      className={classNames(styles.paymentSubscriptionType, `jest-payments-${type}-subscription-type`)}
      onClick={() => onSubscriptionTypeChange(type)}>
      <div className={classNames(
        styles.subscriptionTypeDetail,
        isPro ? 'themePro' : 'themeStandard',
      )}>
        {isPro && (
          <PaymentsRibbon />
        )}
        <div className={styles.icon}>
          {subscriptionIcons[type]}
        </div>
        <div className={styles.subscriptionTitle}>{subscriptionTypeTitle}</div>
        <p className={styles.subscriptionDesc} dangerouslySetInnerHTML={{ __html: description }} />
        <div className={styles.currentSubscriptionLabel}>
          {(subscriptionTypeForLabel) && (
            <CurrentSubscriptionLabel
              subsciptionActiveTill={subscriptionTypeForLabel}
              isPro={isPro} />
          )}
        </div>
        {((isPro && !hasPremiumSubscription) || (!isPro && !hasStandardSubscription && !hasPremiumSubscription)) && (
          <PaymentsAvailableContentCounters
            booksPerSubscriptionCounter={booksPerSubscriptionCounter}
            isPro={isPro}
            isSubscriptionTypeSelected={false} />
        )}
      </div>

      <div className="billetContainerFooter">
        {(isShowOfferLink && isPro) && (
          <PaymentsActionButton
            isPro
            url="/trial/?from=payments"
            text={`14 дней бесплатно`}
            isOfferText
            isSurcharge={false}
            theme="advert"
            extraClassName={styles.subscriptionActionButton} />
        )}
        <PaymentsActionButton
          price={price}
          fullPrice={fullPrice[type]}
          isPro={isPro}
          isSurcharge={isSurcharge}
          extraClassName={styles.subscriptionActionButton}
          isProSubscriberBuysAudioSubscription={isProSubscriberBuysAudioSubscription} />
        {(isShowOfferLink && !isPro) && (
          <div className={styles.hiddenBlock} />
        )}
        <div className={styles.subscriptionFooterText}>
          <span dangerouslySetInnerHTML={{ __html: SUBSCRIPTION_FOOTER_TEXTS[type] }} />
        </div>
      </div>
    </div>
  );
};

PaymentsSubscriptionTypeOffer.propTypes = {
  onSubscriptionTypeChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  payments: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    payments: state.payments,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
};

export default connect(mapStateToProps)(PaymentsSubscriptionTypeOffer);
